import { useState } from 'react'
import { Typography } from '@cannect/new-components/atoms'
import CuratorshipGauge from '@cannect/new-components/atoms/CuratorshipGauge'
import { CuratorshipTiersLegend } from '@cannect/new-components/atoms/CuratorshipGauge/CuratorshipTiersLegend'
import { FiArrowRightCircle, FiMinusCircle, FiPlusCircle } from 'react-icons/fi'
import curatorshipHeroBanner from '../../assets/img/curatorship/microscope-and-professional.png'
import curatorshipSolutionImg from '../../assets/img/curatorship/curatorship-solution.png'
import curatorshipProcessImg from '../../assets/img/curatorship/curatorship-process.png'

const EXAMPLE_PERCENTAGE = 84

const curationCriteria = [
  {
    title: 'GMP Grau Nutricional (Good Manufacturing Practices – Nutritional Grade)',
    description:
      'A certificação GMP Grau Nutricional comprova que o fabricante segue Boas Práticas de Fabricação voltadas à produção de suplementos alimentares e produtos nutricionais. Ela avalia aspectos como controle de matérias-primas, higiene das instalações, qualificação de fornecedores, rastreabilidade, documentação de processos, controle de qualidade e prevenção de contaminações. Embora não possua o mesmo nível de exigência regulatória aplicado à indústria farmacêutica, o GMP Nutricional demonstra que o produto é fabricado dentro de padrões reconhecidos de qualidade e segurança, reduzindo riscos de variações de composição, falhas de processo e contaminações que possam comprometer a experiência e a segurança do consumidor.'
  },
  {
    title: 'GMP Grau Farmacêutico (Good Manufacturing Practices – Pharmaceutical Grade)',
    description:
      'A certificação GMP Grau Farmacêutico representa um dos mais elevados padrões internacionais de qualidade para a fabricação de medicamentos e insumos farmacêuticos. Ela exige controles rigorosos sobre todas as etapas produtivas, incluindo qualificação de equipamentos, validação de processos, controle ambiental, treinamento de equipes, rastreabilidade completa, investigação de desvios e monitoramento contínuo da qualidade. Em produtos à base de cannabis, o GMP Farmacêutico oferece maior garantia de consistência entre lotes, precisão das concentrações declaradas, controle de contaminantes e robustez dos processos produtivos. Isso proporciona maior previsibilidade terapêutica, segurança para prescritores e pacientes e maior confiança de que o produto entregue corresponde às especificações estabelecidas pelo fabricante.'
  },
  {
    title: 'GACP (Good Agricultural and Collection Practices)',
    description:
      'A certificação GACP assegura que a cannabis foi cultivada e colhida seguindo boas práticas agrícolas, com controle rigoroso de solo, água, insumos, pragas e condições de colheita. Isso reduz significativamente riscos de contaminação por pesticidas, metais pesados, micotoxinas e microrganismos, além de garantir maior padronização da matéria-prima vegetal.'
  },
  {
    title: 'Testes de estabilidade',
    description:
      'Os testes de estabilidade avaliam como o produto se comporta ao longo do tempo sob diferentes condições de temperatura, umidade e luz, sendo essenciais para definir prazo de validade e condições adequadas de armazenamento. Em produtos à base de cannabis, eles permitem monitorar a degradação de canabinoides, alterações no perfil de terpenos e possíveis mudanças físico-químicas no veículo, garantindo manutenção da potência, segurança e previsibilidade terapêutica até o final do prazo declarado.'
  },
  {
    title: 'Certificado de armazenamento',
    description:
      'O certificado de armazenamento comprova que o produto foi mantido sob condições controladas de temperatura, umidade, luminosidade e higiene. Esse controle é essencial para preservar a estabilidade dos canabinoides e terpenos, evitar degradação oxidativa e microbiológica e garantir que o produto chegue ao paciente nas mesmas condições de qualidade constatada no CoA.'
  },
  {
    title: 'Certificado de transporte',
    description:
      'O certificado de transporte garante que, durante toda a logística, o produto foi protegido contra variações extremas de temperatura, luz, umidade e manuseio inadequado. Em produtos de cannabis, esse controle é fundamental para evitar degradação química, perdas de potência e alterações no perfil terapêutico antes da chegada ao paciente.'
  },
  {
    title: 'Certificado de rastreabilidade da semente',
    description:
      'A rastreabilidade da semente permite acompanhar todo o histórico do produto, desde o material genético até o produto final. Esse controle garante consistência química entre lotes, transparência na origem da planta, maior previsibilidade terapêutica e facilita auditorias, recalls e investigações de não conformidades.'
  },
  {
    title: 'Certificado de Análise full panel (CoA completo)',
    description:
      'Um certificado de análise completo vai além da dosagem de canabinoides, incluindo análise de solventes residuais, metais pesados, pesticidas, micotoxinas e microbiologia. Ele assegura que o produto atende aos limites de segurança internacionais e fornece confiança clínica ao prescritor e ao paciente sobre a qualidade e a segurança do uso contínuo.'
  },
  {
    title: 'Variabilidade entre lotes',
    description:
      'A baixa variabilidade entre lotes garante previsibilidade terapêutica, permitindo que o paciente tenha respostas clínicas semelhantes a cada nova compra. Em cannabis medicinal, essa padronização é essencial para evitar flutuações de dose, efeitos adversos inesperados e perda de eficácia ao longo do tratamento.'
  },
  {
    title: 'Variabilidade entre CoA e embalagem',
    description:
      'A consistência entre os valores do CoA e as informações declaradas na embalagem é fundamental para a segurança do paciente e para a confiança do prescritor. Diferenças significativas podem levar a erros de dosagem, falhas terapêuticas ou efeitos adversos, além de indicarem fragilidade nos controles de qualidade e no sistema produtivo.'
  },
  {
    title: 'Tipo de veículo',
    description:
      'O tipo de veículo influencia diretamente a estabilidade química dos canabinoides e terpenos, afetando a durabilidade e a qualidade final do produto. Ele também impacta a absorção e a biodisponibilidade, determinando o quanto dos compostos ativos será efetivamente disponibilizado ao organismo. Além disso, o veículo interfere na experiência do paciente — sabor, viscosidade e tolerabilidade — influenciando adesão e segurança do uso.'
  },
  {
    title: 'Apresentação da formulação na embalagem do produto',
    description:
      'A apresentação clara da formulação na embalagem permite que prescritores e pacientes compreendam exatamente quais canabinoides, concentrações e excipientes estão presentes no produto. Essa transparência reduz erros de uso, facilita ajustes de dose e contribui para maior adesão e segurança terapêutica.'
  },
  {
    title: 'Apresentação do espectro na embalagem',
    description:
      'A indicação do espectro (isolado, espectro amplo ou espectro completo) é fundamental para alinhar expectativas terapêuticas e de tolerabilidade. Ela orienta o prescritor quanto à presença ou ausência de THC e outros fitocanabinoides, impactando diretamente eficácia clínica, efeitos adversos e adequação ao perfil do paciente.'
  },
  {
    title: 'Apresentação do lote, validade e QR Code para CoA na embalagem',
    description:
      'A presença de lote, validade e QR Code para acesso ao CoA garante rastreabilidade, transparência e segurança. Esses elementos permitem a verificação da composição real do produto, facilitam recalls quando necessários e asseguram que o paciente utilize um produto dentro do prazo e conforme especificações analíticas.'
  },
  {
    title: 'Certificações como vegano, orgânico e/ou kosher',
    description:
      'Certificações como vegano, orgânico e kosher indicam conformidade com padrões específicos de produção e processamento. Além de atender restrições éticas, religiosas ou alimentares, essas certificações reforçam o controle sobre insumos, contaminantes e práticas sustentáveis, elevando a confiança do consumidor.'
  },
  {
    title: 'Indicação de açúcar e/ou flavorizante',
    description:
      'A ausência de açúcar e flavorizantes reduz o risco de interações indesejadas, reações adversas e desconfortos gastrointestinais, especialmente em pacientes sensíveis ou em uso crônico. Também evita interferências na absorção e mantém o perfil farmacotécnico mais previsível e adequado ao uso terapêutico.'
  },
  {
    title: 'Trava de segurança',
    description:
      'A trava de segurança é essencial para prevenir ingestão acidental, especialmente por crianças e animais. Em produtos de cannabis medicinal, esse mecanismo agrega uma camada crítica de proteção, reduzindo riscos domésticos e reforçando a responsabilidade sanitária do fabricante.'
  },
  {
    title: 'Graduação da pipeta',
    description:
      'A pipeta graduada permite uma administração precisa e reprodutível da dose, fator-chave para o sucesso terapêutico. A precisão volumétrica reduz erros de dosagem, facilita titulações progressivas e aumenta a confiança do paciente no uso diário do produto.'
  },
  {
    title: 'Tipo de vidro',
    description:
      'O tipo de vidro importa porque ele determina quanto de luz, especialmente UV, o produto recebe, afetando diretamente a estabilidade dos canabinoides e terpenos. Vidros mais protetores (âmbar, preto, violeta) reduzem degradação, oxidação e perda de potência. Assim, a escolha do vidro é um fator crítico para preservar qualidade, segurança e eficácia dos produtos à base de cannabis.'
  },
  {
    title: 'Tipo de frasco',
    description:
      'O tipo de frasco influencia diretamente a proteção contra luz, oxigênio e umidade. Frascos opacos oferecem maior proteção à estabilidade de canabinoides e terpenos, enquanto frascos translúcidos exigem maior controle de armazenamento. A escolha adequada do material também impacta resistência, vedação e segurança durante transporte e uso.'
  },
  {
    title: 'Método de extração',
    description:
      'O método de extração determina a pureza, o perfil químico e o risco de contaminantes no produto final. Processos mais controlados, como CO₂ supercrítico e etanol a frio, tendem a preservar canabinoides e terpenos e reduzir solventes residuais, enquanto métodos menos refinados exigem controles analíticos mais rigorosos para garantir segurança e qualidade.'
  },
  {
    title: 'Teste Prático e Análise Física:',
    description:
      'Produtos como óleos passam por uma validação prática, que inclui: análise da embalagem, rótulo, frasco e pipeta; e teste de gotas/mL, garantindo que a dosagem seja precisa. Esse processo é repetido ao menos três vezes para minimizar variações e assegurar a fidedignidade da dosagem.'
  }
]

const faqItems = [
  {
    question: 'Como escolher um produto de cannabis?',
    answer: (
      <>
        <p className="mb-3">
          A escolha de um produto de cannabis medicinal deve ir além da concentração de CBD ou THC. É importante avaliar
          fatores como:
        </p>
        <ul className="mb-3 list-disc pl-5">
          <li>Qualidade da matéria-prima</li>
          <li>Método de extração</li>
          <li>Controle de contaminantes</li>
          <li>Certificações do fabricante</li>
          <li>Documentação técnica disponível</li>
        </ul>
        <p className="mb-3">
          Produtos confiáveis costumam disponibilizar Certificados de Análise (CoA), que comprovam a composição do
          produto e a ausência de contaminantes relevantes, como metais pesados, pesticidas, solventes residuais,
          microrganismos e micotoxinas. Também é recomendável verificar se o fabricante possui certificações como GMP
          (Boas Práticas de Fabricação) e GACP (Boas Práticas Agrícolas e de Coleta).
        </p>
        <p className="mb-3">
          Além disso, a escolha da formulação deve considerar fatores como proporção entre CBD e THC, espectro do
          extrato (Full Spectrum, Broad Spectrum ou Isolado), tipo de veículo utilizado e adequação às necessidades
          individuais do paciente.
        </p>
        <p className="last:mb-0">
          No Brasil, a prescrição é obrigatória para o uso de produtos de cannabis medicinal e pode ser realizada por
          médicos ou dentistas, conforme a regulamentação vigente. A escolha do produto deve ser feita com
          acompanhamento profissional, considerando o contexto clínico e as necessidades específicas de cada paciente.
        </p>
      </>
    )
  },
  {
    question: 'O que é CoA?',
    answer: (
      <>
        <p className="mb-3">
          CoA é a sigla para Certificate of Analysis, ou Certificado de Análise. Trata-se de um documento que apresenta
          os resultados das análises realizadas em determinado lote de um produto, idealmente emitido por um laboratório
          independente e sem vínculo com a marca fabricante.
        </p>
        <p className="mb-3">
          Em produtos à base de cannabis, o CoA permite confirmar a concentração dos canabinoides presentes, como CBD,
          THC, CBG e CBN, além de avaliar parâmetros de segurança e qualidade. Dependendo da abrangência do teste, o
          documento também pode incluir análises de pesticidas, metais pesados, solventes residuais, microbiologia,
          micotoxinas e terpenos.
        </p>
        <p className="mb-3">
          O CoA é uma das principais ferramentas para verificar se o conteúdo do produto corresponde às informações
          declaradas pelo fabricante e se o lote atende critérios mínimos de qualidade e segurança.
        </p>
        <p className="last:mb-0">
          De forma geral, quanto mais completo e transparente for o Certificado de Análise, especialmente quando emitido
          por um laboratório terceiro e independente, maior tende a ser a confiabilidade das informações disponíveis
          sobre aquele produto.
        </p>
      </>
    )
  },
  {
    question: 'Como interpretar um CoA?',
    answer: (
      <>
        <p className="mb-3">
          O Certificado de Análise (CoA) é um documento que apresenta os resultados das análises realizadas em um lote
          específico do produto. Ao interpretá-lo, é importante verificar se as concentrações de canabinoides
          correspondem às informações do rótulo e se o produto foi aprovado nas análises de contaminantes, como metais
          pesados, pesticidas, solventes residuais e microrganismos.
        </p>
        <p className="last:mb-0">
          Também vale conferir se o número do lote e a data da análise estão identificados no documento. Um CoA completo
          e transparente é uma das principais evidências de qualidade, segurança e rastreabilidade de um produto de
          cannabis medicinal.
        </p>
      </>
    )
  },
  {
    question: 'O que é GMP?',
    answer: (
      <>
        <p className="mb-3">
          GMP é a sigla para Good Manufacturing Practices, ou Boas Práticas de Fabricação. Trata-se de um conjunto de
          normas e procedimentos destinados a garantir que um produto seja fabricado de forma consistente, controlada e
          segura.
        </p>
        <p className="mb-3">
          A certificação GMP avalia aspectos como qualificação de fornecedores, controle de matérias-primas,
          rastreabilidade, validação de processos, treinamento de equipes, documentação técnica, controle de qualidade e
          prevenção de contaminações.
        </p>
        <p className="mb-3">
          No mercado de cannabis medicinal, a certificação GMP é um importante indicador de maturidade e qualidade
          produtiva, pois demonstra que o fabricante segue padrões reconhecidos internacionalmente para reduzir riscos
          de falhas, desvios de qualidade e inconsistências entre lotes.
        </p>
        <p className="last:mb-0">
          Embora a certificação GMP não substitua a necessidade de análises laboratoriais do produto final, ela
          representa um importante elemento de confiança dentro da cadeia produtiva.
        </p>
      </>
    )
  },
  {
    question: 'Como saber se um óleo de cannabis é seguro?',
    answer: (
      <>
        <p className="mb-3">
          Um óleo de cannabis seguro deve apresentar documentação que permita avaliar sua qualidade, composição e
          rastreabilidade. Um dos principais documentos é o Certificado de Análise (CoA), que comprova a concentração
          dos canabinoides e a realização de testes para contaminantes relevantes.
        </p>
        <p className="mb-3">
          Também é importante verificar se o fabricante segue padrões de qualidade reconhecidos, como GMP e GACP, além
          de avaliar informações sobre método de extração, lote, validade, armazenamento e composição do produto.
        </p>
        <p className="mb-3">
          A segurança de um óleo não depende apenas da presença de CBD ou THC, mas também da ausência de contaminantes
          como pesticidas, metais pesados, solventes residuais, microrganismos e micotoxinas.
        </p>
        <p className="last:mb-0">
          Produtos que disponibilizam informações técnicas completas e apresentam maior transparência sobre sua
          fabricação tendem a oferecer maior previsibilidade e segurança para pacientes e profissionais de saúde.
        </p>
      </>
    )
  },
  {
    question: 'Qual a diferença entre Full Spectrum, Broad Spectrum e Isolado?',
    answer: (
      <>
        <p className="mb-3">
          A diferença está na presença e na sinergia dos compostos da planta: o Full Spectrum preserva todos os
          canabinoides e terpenos (incluindo o THC); o Broad Spectrum mantém os compostos, mas remove o THC; e o Isolado
          contém apenas o canabinoide purificado (geralmente CBD puro). Veja o comparativo:
        </p>
        <div className="mb-3 overflow-x-auto">
          <table className="w-full border-collapse text-xs">
            <thead>
              <tr className="bg-secondary-100 text-left">
                <th className="border border-solid border-gray-200 px-2 py-2 font-semibold text-[#433f3e]">
                  Tipo de Extrato
                </th>
                <th className="border border-solid border-gray-200 px-2 py-2 font-semibold text-[#433f3e]">CBD</th>
                <th className="border border-solid border-gray-200 px-2 py-2 font-semibold text-[#433f3e]">THC</th>
                <th className="border border-solid border-gray-200 px-2 py-2 font-semibold text-[#433f3e]">
                  Outros canabinoides e terpenos
                </th>
                <th className="border border-solid border-gray-200 px-2 py-2 font-semibold text-[#433f3e]">
                  Efeito Entourage (Sinergia)
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-solid border-gray-200 px-2 py-2 font-medium">Full Spectrum</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Sim</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Sim</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Sim (completo)</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Alto (máxima eficiência terapêutica)</td>
              </tr>
              <tr>
                <td className="border border-solid border-gray-200 px-2 py-2 font-medium">Broad Spectrum</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Sim</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Não (zero / indetectável)</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Sim (parcial)</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Médio (boa sinergia, sem THC)</td>
              </tr>
              <tr>
                <td className="border border-solid border-gray-200 px-2 py-2 font-medium">Isolado</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Sim</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Não</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Não (apenas a molécula isolada)</td>
                <td className="border border-solid border-gray-200 px-2 py-2">Nulo (ação terapêutica linear)</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="last:mb-0">
          Cada tipo de extrato possui características próprias de composição e padronização. A escolha entre eles deve
          considerar os objetivos terapêuticos, a tolerabilidade individual e a orientação do profissional de saúde
          responsável pelo acompanhamento.
        </p>
      </>
    )
  },
  {
    question: 'O que analisar antes de comprar cannabis medicinal?',
    answer: (
      <>
        <p className="mb-3">
          Antes de adquirir um produto de cannabis medicinal, é recomendável avaliar alguns critérios fundamentais de
          qualidade e segurança:
        </p>
        <ul className="mb-3 list-disc pl-5">
          <li>Certificado de Análise (CoA) atualizado;</li>
          <li>Presença de testes para contaminantes;</li>
          <li>Certificações de qualidade, como GMP e GACP;</li>
          <li>Transparência sobre composição e concentração dos canabinoides;</li>
          <li>Informações sobre lote, validade e armazenamento;</li>
          <li>Método de extração utilizado;</li>
          <li>Tipo de espectro (Full Spectrum, Broad Spectrum ou Isolado);</li>
          <li>Rastreabilidade do produto e da matéria-prima.</li>
        </ul>
        <p className="last:mb-0">
          A análise desses fatores ajuda a reduzir incertezas e permite uma comparação mais criteriosa entre diferentes
          marcas e formulações disponíveis no mercado.
        </p>
      </>
    )
  },
  {
    question: 'Como saber se um produto de cannabis é confiável?',
    answer: (
      <>
        <p className="mb-3">
          A confiabilidade de um produto de cannabis pode ser avaliada por meio da combinação de documentação técnica,
          certificações e transparência do fabricante.
        </p>
        <p className="mb-3">
          Produtos mais confiáveis costumam disponibilizar Certificados de Análise completos, informações claras sobre
          sua composição, rastreabilidade dos lotes e evidências de controle de qualidade ao longo do processo
          produtivo.
        </p>
        <p className="mb-3">
          A presença de certificações como GMP e GACP, associada à realização de testes laboratoriais abrangentes,
          contribui para demonstrar o compromisso do fabricante com qualidade, segurança e padronização.
        </p>
        <p className="last:mb-0">
          Além disso, a consistência entre diferentes lotes e a correspondência entre os resultados laboratoriais e as
          informações declaradas na embalagem são indicadores importantes de confiabilidade.
        </p>
      </>
    )
  },
  {
    question: 'O que é GACP?',
    answer: (
      <>
        <p className="mb-3">
          GACP é a sigla para Good Agricultural and Collection Practices, ou Boas Práticas Agrícolas e de Coleta.
        </p>
        <p className="mb-3">
          Essa certificação estabelece critérios para o cultivo, manejo, colheita, processamento inicial e armazenamento
          da matéria-prima vegetal. Seu objetivo é garantir que a planta seja produzida de forma padronizada e com menor
          risco de contaminações.
        </p>
        <p className="mb-3">
          No caso da cannabis medicinal, a certificação GACP ajuda a controlar fatores como qualidade do solo, água
          utilizada, fertilizantes, pesticidas, condições de cultivo e procedimentos de colheita.
        </p>
        <p className="last:mb-0">
          Como resultado, contribui para maior consistência da matéria-prima utilizada na fabricação dos produtos,
          favorecendo qualidade, rastreabilidade e previsibilidade ao longo da cadeia produtiva.
        </p>
      </>
    )
  },
  {
    question: 'GMP farmacêutico vs GMP nutricional: qual a diferença?',
    answer: (
      <>
        <p className="mb-3">
          Tanto o GMP Farmacêutico quanto o GMP Nutricional certificam que o fabricante segue Boas Práticas de
          Fabricação, mas os níveis de exigência regulatória são diferentes.
        </p>
        <p className="mb-3">
          O GMP Nutricional é voltado para suplementos alimentares e produtos nutricionais. Ele avalia aspectos como
          controle de matérias-primas, higiene, documentação, rastreabilidade e prevenção de contaminações.
        </p>
        <p className="mb-3">
          Já o GMP Farmacêutico segue requisitos mais rigorosos, compatíveis com a indústria farmacêutica. Além dos
          controles básicos, exige validação de processos, monitoramento ambiental, qualificação de equipamentos,
          controles analíticos mais robustos e sistemas mais rigorosos de garantia da qualidade.
        </p>
        <p className="last:mb-0">
          De forma geral, ambas as certificações demonstram compromisso com qualidade e segurança. No entanto, o GMP
          Farmacêutico representa um padrão regulatório mais elevado e abrangente dentro da cadeia produtiva.
        </p>
      </>
    )
  }
]

export const CuratorshipPage = () => {
  const [openCriteria, setOpenCriteria] = useState<number>(0)
  const [openFaq, setOpenFaq] = useState<number>(0)

  return (
    <div className="w-full max-w-full bg-white">
      <section className="container max-w-6xl pt-4 md:pt-3">
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src={curatorshipHeroBanner}
            alt="Curadoria Técnica de Produtos Cannect"
            className="h-[260px] w-full object-cover sm:h-[320px] md:h-[405px]"
          />
          <div className="absolute inset-0 flex flex-col justify-center gap-3 px-6 md:gap-4 md:px-16">
            <Typography.Heading
              type="headingTwo"
              weight="semibold"
              className="text-[28px] leading-[1.2] text-[#433f3e] sm:text-[32px] md:text-[36px]">
              Curadoria Técnica <br /> de Produtos Cannect
            </Typography.Heading>
            <Typography.Text
              weight="semibold"
              className="max-w-[394px] text-base leading-[1.3] text-[#433f3e] md:text-[20px]">
              Qualidade, procedência e segurança atestados por quem entende
            </Typography.Text>
          </div>
        </div>
      </section>

      <section className="bg-white py-section">
        <div className="container max-w-6xl">
          <div>
            {/* Bloco 1: imagem (esquerda) + texto (direita) */}
            <div className="flex flex-col gap-5 md:grid md:grid-cols-2">
              <div className="relative h-[260px] w-full overflow-hidden rounded-2xl md:h-auto">
                <img
                  src={curatorshipProcessImg}
                  alt="Curadoria Técnica Cannect"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
              <div className="flex flex-col justify-center gap-4 rounded-2xl bg-secondary-100 px-6 py-8 text-[#433f3e] md:h-[616px] md:px-12 md:py-16">
                <div className="flex flex-col gap-2">
                  <Typography.Heading type="headingFive" weight="semibold" className="text-[#433f3e]">
                    O Desafio do Mercado de Cannabis Medicinal
                  </Typography.Heading>
                  <Typography.Text className="text-sm leading-[1.5] text-[#433f3e]">
                    Embora em forte expansão global, o mercado de Cannabis medicinal ainda carece de padrões uniformes
                    de qualidade e segurança. Essa falta de padronização dificulta a comparação técnica entre marcas e
                    lotes, impactando diretamente a previsibilidade terapêutica e a tomada de decisão clínica.
                  </Typography.Text>
                </div>
                <div className="flex flex-col gap-2">
                  <Typography.Text className="text-sm leading-[1.5] text-[#433f3e]">
                    Para trazer máxima transparência a esse cenário, estruturamos a Curadoria Técnica de Produtos de
                    Cannabis. Trata-se de um modelo analítico rigoroso, desenvolvido com base em literatura científica,
                    diretrizes internacionais e referências farmacopeicas, projetado para analisar sistematicamente as
                    opções do mercado.
                  </Typography.Text>
                </div>
              </div>
            </div>

            <div aria-hidden className="h-10 w-full shrink-0" />
            {/* Bloco 2: texto (esquerda) + imagem (direita) */}
            <div className="flex flex-col gap-5 md:grid md:grid-cols-2">
              <div className="flex flex-col justify-center gap-4 rounded-2xl bg-secondary-100 px-6 py-8 text-[#433f3e] md:h-[616px] md:px-12 md:py-16">
                <div className="flex flex-col gap-2">
                  <Typography.Heading type="headingFive" weight="semibold" className="text-[#433f3e]">
                    Como Funciona a Nossa Avaliação Técnica?
                  </Typography.Heading>
                  <Typography.Text className="text-sm leading-[1.5] text-[#433f3e]">
                    Não analisamos o produto apenas uma vez. A cada novo lote disponibilizado, reavaliamos os dados
                    laboratoriais e regulatórios para acompanhar a consistência produtiva ao longo do tempo. Analisamos
                    detalhadamente:
                  </Typography.Text>
                  <ul className="flex list-disc flex-col gap-1 pl-5 text-sm leading-[1.5] text-[#433f3e]">
                    <li>
                      <strong>Padrões de Qualidade:</strong> Qualidade da matéria-prima e método de extração.
                    </li>
                    <li>
                      <strong>Segurança Restrita:</strong> Controle rigoroso de contaminantes e conformidade
                      regulatória.
                    </li>
                    <li>
                      <strong>Transparência Total:</strong> Análise minuciosa de certificados de análise (CoA) e
                      documentação técnica.
                    </li>
                  </ul>
                </div>
                <div className="flex flex-col gap-2">
                  <Typography.Heading type="headingFive" weight="semibold" className="text-[#433f3e]">
                    O Impacto na Prática Clínica
                  </Typography.Heading>
                  <Typography.Text className="text-sm leading-[1.5] text-[#433f3e]">
                    O objetivo final da nossa curadoria é apoiar decisões médicas e proteger o paciente, promovendo:
                  </Typography.Text>
                  <ul className="flex list-disc flex-col gap-1 pl-5 text-sm leading-[1.5] text-[#433f3e]">
                    <li>Maior rastreabilidade e embasamento técnico na escolha de produtos.</li>
                    <li>Facilitar a interpretação de dados complexos por profissionais de saúde.</li>
                    <li>Garantir um tratamento mais seguro e previsível.</li>
                  </ul>
                </div>
              </div>
              <div className="relative h-[260px] w-full overflow-hidden rounded-2xl md:h-auto">
                <img
                  src={curatorshipSolutionImg}
                  alt="Processo de Curadoria Técnica"
                  className="absolute inset-0 h-full w-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container max-w-6xl pb-section">
        <Typography.Heading type="headingFive" className="mb-6 text-[#433f3e] md:mb-8 md:text-2xl">
          O que é considerado no processo de Curadoria:
        </Typography.Heading>

        <div className="flex flex-col">
          {curationCriteria.map((item, index) => {
            const isOpen = openCriteria === index

            return (
              <div key={item.title}>
                <button
                  type="button"
                  onClick={() => setOpenCriteria(isOpen ? -1 : index)}
                  className="flex w-full appearance-none items-center justify-between gap-4 border-none bg-transparent py-5 text-left">
                  <span className="text-sm font-semibold text-[#433f3e] md:text-base">{item.title}</span>
                  {isOpen ? (
                    <FiMinusCircle className="size-6 shrink-0 text-gray-500" />
                  ) : (
                    <FiPlusCircle className="size-6 shrink-0 text-gray-500" />
                  )}
                </button>
                {isOpen && (
                  <Typography.Text className="pb-6 text-sm leading-[1.5] text-neutral-600">
                    {item.description}
                  </Typography.Text>
                )}
                <div className="h-px w-full bg-gray-200" />
              </div>
            )
          })}
        </div>
      </section>

      <section className="container max-w-6xl pb-section">
        <Typography.Heading type="headingFive" className="mb-8 text-[#433f3e] md:mb-10 md:text-2xl">
          Cada produto avaliado recebe um percentual de aderência aos critérios da Curadoria Técnica
        </Typography.Heading>

        <div className="rounded-2xl border border-solid border-gray-200 bg-white p-6 md:p-10">
          <CuratorshipGauge
            percentage={EXAMPLE_PERCENTAGE}
            variant="full"
            size="lg"
            publicContent
            hideWhenEmpty={false}
            caption={false}
            className="mx-auto"
          />

          <Typography.Text className="mt-8 block text-center text-xs italic text-neutral-500">
            Exemplo ilustrativo. O percentual exibido em cada produto vem da avaliação da Curadoria.
          </Typography.Text>

          {/* <div className="mt-8 border-t border-solid border-gray-200 pt-8">
            <CuratorshipTiersLegend />
          </div> */}
        </div>

        <Typography.Text className="mt-6 block text-sm leading-[1.5] text-neutral-600">
          O percentual reflete a aderência do produto ao conjunto de critérios técnicos avaliados pela Curadoria, dos
          certificados da marca à embalagem final.
        </Typography.Text>
      </section>

      <section className="container max-w-6xl py-section">
        <div className="mb-12 h-px w-full bg-gray-200 md:mb-16" />
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-12">
          <div className="!space-y-4">
            <Typography.Heading type="headingFive" weight="semibold" className="text-[#433f3e]">
              Organização e responsabilidade
            </Typography.Heading>
            <Typography.Text>
              Antes de integrar qualquer produto, realizamos uma Curadoria Técnica contínua conduzida por médicos e
              farmacêuticos, garantindo uma análise rigorosa que une as visões clínica e técnica lote a lote.
            </Typography.Text>
          </div>
          <div className="!space-y-4">
            <Typography.Heading type="headingFive" weight="semibold" className="text-[#433f3e]">
              Compromisso com segurança
            </Typography.Heading>
            <Typography.Text>
              Nossa reavaliação contínua acompanha as evoluções do mercado e exigências regulatórias. Esse pilar
              assegura um ecossistema terapêutico:
            </Typography.Text>
            <ul className="flex list-disc flex-col gap-1 pl-5 text-neutral-600">
              <li>Seguro e focado no paciente.</li>
              <li>Transparente e auditável.</li>
              <li>Confiável para profissionais de saúde.</li>
            </ul>
          </div>
          <div className="!space-y-4">
            <Typography.Heading type="headingFive" weight="semibold" className="text-[#433f3e]">
              Por que escolher a Cannect?
            </Typography.Heading>
            <Typography.Text>
              A Cannect se posiciona como referência nacional em qualidade e segurança na Cannabis Medicinal. Com um
              rigoroso padrão de avaliação, a plataforma facilita o acesso a tratamentos seguros, garantindo confiança
              para médicos, cirurgiões-dentistas e pacientes.
            </Typography.Text>
          </div>
        </div>
      </section>

      <section className="container max-w-6xl pb-section">
        <Typography.Heading type="headingFive" className="mb-6 text-[#433f3e] md:mb-8 md:text-3xl">
          Perguntas Frequentes
        </Typography.Heading>

        <div className="flex flex-col">
          {faqItems.map((item, index) => {
            const isOpen = openFaq === index

            return (
              <div key={item.question}>
                <button
                  type="button"
                  onClick={() => setOpenFaq(isOpen ? -1 : index)}
                  className="flex w-full appearance-none items-center justify-between gap-4 border-none bg-transparent py-5 text-left">
                  <span className="text-sm font-semibold text-[#433f3e] md:text-base">{item.question}</span>
                  {isOpen ? (
                    <FiMinusCircle className="size-6 shrink-0 text-gray-500" />
                  ) : (
                    <FiPlusCircle className="size-6 shrink-0 text-gray-500" />
                  )}
                </button>
                {isOpen && <div className="pb-6 text-sm leading-[1.5] text-neutral-600">{item.answer}</div>}
                <div className="h-px w-full bg-gray-200" />
              </div>
            )
          })}
        </div>
      </section>

      <section className="container max-w-6xl pb-section">
        <Typography.Heading type="headingFive" className="mb-6 text-[#433f3e] md:mb-8 md:text-2xl">
          Quer saber mais?
        </Typography.Heading>

        <div className="flex flex-col gap-6 md:flex-row md:gap-8">
          <div className="flex w-full flex-col gap-4 rounded-2xl bg-white px-5 py-8 shadow-[0_2px_16px_rgba(0,0,0,0.08)] md:p-16">
            <Typography.Heading type="headingFive" weight="semibold" className="text-[#433f3e]">
              Profissionais de saúde
            </Typography.Heading>
            <Typography.Text>
              Se você deseja entender como a Curadoria Técnica da Cannect apoia a segurança das suas prescrições, entre
              em contato com nosso time de Relacionamento Médico.
            </Typography.Text>
            <button
              type="button"
              onClick={() =>
                window.open(
                  'https://api.whatsapp.com/send?phone=5511990159720&text=Ol%C3%A1!%20Gostaria%20de%20entender%20um%20pouco%20mais%20sobre%20a%20Curadoria%20T%C3%A9cnica%20de%20Produtos',
                  '_blank'
                )
              }
              className="mt-2 inline-flex w-fit appearance-none items-center gap-2 border-none bg-transparent p-0 font-semibold text-secondary hover:opacity-80">
              Falar com relacionamento médico
              <FiArrowRightCircle className="size-5" />
            </button>
          </div>
          <div className="flex w-full flex-col gap-4 rounded-2xl bg-white px-5 py-8 shadow-[0_2px_16px_rgba(0,0,0,0.08)] md:p-16">
            <Typography.Heading type="headingFive" weight="semibold" className="text-[#433f3e]">
              Seja um parceiro estratégico
            </Typography.Heading>
            <Typography.Text>
              Caso sua marca ainda não faça parte do nosso portfólio, acione nossa equipe especializada: Cadastrar Minha
              Marca na Plataforma.
            </Typography.Text>
            <button
              type="button"
              onClick={() => window.open('mailto:marcas@cannect.com.br')}
              className="mt-2 inline-flex w-fit appearance-none items-center gap-2 border-none bg-transparent p-0 text-left font-semibold text-secondary hover:opacity-80">
              Cadastrar Minha Marca na Plataforma
              <FiArrowRightCircle className="size-5 shrink-0" />
            </button>
          </div>
        </div>
        <Typography.Text className="mx-auto mt-8 text-center md:mt-16">
          Estamos prontos para esclarecer dúvidas e construir, juntos, um mercado de Cannabis <br />
          Medicinal mais seguro, transparente e de qualidade.
        </Typography.Text>
      </section>
    </div>
  )
}
